import dayjs from 'dayjs';
import { fromEnumAsString, toEnumFromString } from '../../serialization/enum-utils.js';
import { MapUtils } from '../../utility/map-utils.js';
import { TimeZone } from '../../time/timezone.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';
import { SyncEvent, SyncEventSource } from '../sync-event.js';

export class EventArchivedEvent extends SyncEvent {
  static readonly TYPE_ID: string = '13d3b3f651dc4911b340d0dec4ab6666';

  constructor(
      public readonly uniqueId: string,
      public readonly creatorId: string | null,
      public readonly deviceId: string | null,
      public readonly creationDate: dayjs.Dayjs,
      public readonly source: SyncEventSource,
      public readonly eventId: string,
  ) {
    super();
  }

  get $typeId(): string {
    return EventArchivedEvent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): EventArchivedEvent {
    return new EventArchivedEvent(
        MapUtils.get<string>(map, 'uniqueId'),
        MapUtils.getOrNull<string>(map, 'creatorId'),
        MapUtils.getOrNull<string>(map, 'deviceId'),
        context.decodeDate(MapUtils.get<number>(map, 'creationDate')),
        toEnumFromString(MapUtils.get<string>(map, 'source'), SyncEventSource),
        MapUtils.get<string>(map, 'eventId'),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'uniqueId': this.uniqueId,
      'creatorId': this.creatorId,
      'deviceId': this.deviceId,
      'creationDate': context.encodeDate(this.creationDate),
      'source': fromEnumAsString(this.source),
      'eventId': this.eventId,
    };
  }

  clone(): this {
    return new EventArchivedEvent(
        this.uniqueId,
        this.creatorId,
        this.deviceId,
        TimeZone.cloneDate(this.creationDate),
        this.source,
        this.eventId,
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.uniqueId === this.uniqueId &&
        other.creatorId === this.creatorId &&
        other.deviceId === this.deviceId &&
        other.creationDate === this.creationDate &&
        other.source === this.source &&
        other.eventId === this.eventId;
  }
}

export class EventArchivedEventBuilder extends DataModelBuilder<EventArchivedEvent> {
  build(context: SerializationContext, map: SerializedData): EventArchivedEvent {
    return EventArchivedEvent.fromMap(context, map);
  }
}
